<template>
 <div :class="windowClass">
    <v-row no-gutters class="pa-2">
        <v-col cols="12">
          <v-card>
             <v-toolbar >
                   
                  <span style="width: 270px;" class="ml-4">
                       <v-menu
                        ref="menu"
                        v-model="menu"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        min-width="300px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            :value="from_date +' - '+to_date"
                            label="Date range"
                            prepend-icon="mdi-calendar"
                              dense
                              solo
                              hide-details
                            readonly
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker v-model="from_date" no-title scrollable class="mr-1">  </v-date-picker>
                         <v-date-picker v-model="to_date" no-title scrollable @input="querySales(),menu = false">  </v-date-picker>
                      </v-menu>
                  </span>
                   <span style="width: 290px;" class="ml-2">
                        <v-text-field
                            v-model="search"
                            append-icon="mdi-magnify"
                            label="Search"
                            solo
                            dense
                            hide-details
                        ></v-text-field>
                        </span>
                        <v-spacer/>
                        <v-btn small text color="success"  @click="form=true"><v-icon left >mdi-plus-box</v-icon> New Sales</v-btn>
                        
          </v-toolbar>

          
               <v-data-table
                    class="va-table mt-2"
                    :headers="headers"
                    :search="search"
                    :items="sales"
                    >
                      <template v-slot:body="{ items }">
                        <tbody>
                        <tr v-for="(item,index) in items" :key="index">
                           <td>
                             <v-icon  left small color="error" @click="salesItem=item, confirm=true" v-if="item.status == 'on-process'" >mdi-delete</v-icon>
                             <v-icon left small color="success" @click="$router.push('sales-view/' + item.id).catch(err => {})">mdi-open-in-new</v-icon>
                            {{item.invoice}}
                            </td>
                              <td>{{item.type}}</td>
                            <td>{{item.trade_name}}</td>
                            <td>{{item.delivered_date | moment('YY-MMM-DD')}}</td>
                            <td :class="STATUS_TEXT(item.status)">{{item.status}}</td>
                             <td>{{item.payment_type}}</td>
                            <td class="text-right">{{$money(item.amount)}}</td>
                        </tr>
                        </tbody>
                    </template>
                </v-data-table>
            </v-card>
        </v-col>
    </v-row>
      <va-sales-form :show="form" @DialogEvent="fEvent"/>
        <va-confirm :show="confirm" cancelbtn="No" okbtn="Void" text="Would you like to void this sales?" @DialogEvent="cEvent"/>
</div>
</template>
<script>
import {
  mapMutations
} from 'vuex'
  export default {
    data: () => ({
      menu: false,
      form:false,
      confirm: false,
        search:'',
        from_date:'',
        to_date: '',
        date_range:"",
        salesItem:{},
        sales:[],
        per_type:'Overall',
          headers: [
          { text: 'Invoice #', value: 'invoice', sortable: false },
          { text: 'Type', value: 'type', sortable: false },
          { text: 'Customer', value: 'trade_name', sortable: false },
          { text: 'Invoice Date', value: 'created', sortable: false },
           { text: 'Status', value: 'status', sortable: false},
            { text: 'Method', value: 'payment_type', sortable: false},
            { text: 'Amount', align:'right', value: 'amount', sortable: false}
        ],
    }),
    beforeCreate: function () {
      if (!this.$session.exists()) {
        this.$router.push('/')
      }
    },
    created() {
       if (this.$session.exists()) {
          this.$http.defaults.headers.common['Authorization'] = 'Bearer ' + this.$session.get('jwt')
          this.SET_MENUS()
          this.GET_SETTINGS()
          this.setLoggedIn(true) 
           this.GET_CUSTOMERS('active')
         this.initRange()
          this.querySales()
        }
    },
    computed:{
       windowClass() {
        if(this.$store.state.responsive){
          return "va-reponsive"
        } else {
          return "va-not-reponsive"
        }
      },
      TOTAL_AMOUNT(){
         var total =  this.sales.reduce((res, item)=>res += this.$IsNum(item.amount),0)
        return total
      }
    },
    methods: {
      ...mapMutations(['setAlert', 'setAlertColor', 'setAlertText', 'setLoggedIn', 'setOverlayLoading']),
      initRange(){
        var current_date = this.$moment()
         var startdate = current_date.subtract(7, "days")
          this.from_date =  this.$moment(startdate).format("YYYY-MM-DD")
          this.to_date =  this.$moment().format("YYYY-MM-DD")
      },
      querySales(){
        this.sales=[]
        this.setOverlayLoading(true)
          this.$http.post("sales/query", {from_date:this.from_date, to_date: this.to_date}).then(response => {
                response.data.items !=null?this.sales = response.data.items:this.sales=[]
                setTimeout(()=>{this.setOverlayLoading(false)}, 600)
               }).catch(e => {
                console.log(e.data)
            })
      },
      cEvent(data) {
        this.confirm = false
        if(data != 'cancel') {
          this.initRange()
            this.voidSales()
        }
      },
      fEvent(){
        this.form = false
        this.initRange()
        this.querySales()
      },
      voidSales(){
        var param = {}
        param.invoice = this.salesItem.invoice
        param.id = parseInt(this.salesItem.id)
        this.$http.post("sales/void", param).then(response => {
           this.GET_RESPONSE(response)
           this.initRange()
           this.querySales()
            }).catch(e => {
            console.log(e.data)
        })
      },
    },
  }
</script>